let activeTaskCount = 0
let overlayElement: HTMLDivElement | null = null

function ensureStyles() {
  if (document.querySelector('style[data-istat-loading]')) return

  const style = document.createElement('style')
  style.setAttribute('data-istat-loading', '')
  style.textContent = `
    .istat-loading-spinner {
      width: 48px;
      height: 48px;
      border: 5px solid rgba(59, 130, 246, 0.2);
      border-top-color: rgb(59, 130, 246);
      border-radius: 50%;
      animation: istat-loading-spin 0.8s linear infinite;
    }
    @keyframes istat-loading-spin {
      to { transform: rotate(360deg); }
    }
  `
  document.head.appendChild(style)
}

function mountOverlay() {
  if (overlayElement) return

  ensureStyles()
  overlayElement = document.createElement('div')
  overlayElement.className = 'istat-loading-overlay'
  Object.assign(overlayElement.style, {
    position: 'fixed',
    inset: '0',
    zIndex: '10000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 255, 255, 0.6)',
  })

  const spinner = document.createElement('div')
  spinner.className = 'istat-loading-spinner'
  overlayElement.appendChild(spinner)
  document.body.appendChild(overlayElement)
}

function unmountOverlay() {
  overlayElement?.remove()
  overlayElement = null
}

/**
 * 작업이 영원히 끝나지 않으면 입력 차단도 유지된다. 호출자는 반드시 정착하는 Promise를 넘긴다.
 */
export async function withLoadingOverlay<T>(task: () => Promise<T>): Promise<T> {
  activeTaskCount += 1
  if (activeTaskCount === 1) mountOverlay()

  try {
    return await task()
  } finally {
    activeTaskCount -= 1
    if (activeTaskCount === 0) unmountOverlay()
  }
}
